//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

export const DarkGradientOverlay = () => {
  return (
    <>
      <DarkGradientTop />
      <DarkGradientBottom />
    </>
  );
};

export const DarkGradientBottom = styled.div`
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))
    border-box;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 100% 40%;
  transition: background-size 100ms ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const DarkGradientTop = styled.div`
  background-repeat: no-repeat;
  background-size: 100% 40%;
  transition: background-size 100ms ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center top;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0))
    border-box;
`;
